import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Router } from '@angular/router';
import { Observable, throwError, catchError } from 'rxjs';

import { MonitoringService } from '../services/monitoring.service';

export const HTTP_ERROR_401_ROUTE = new InjectionToken<string[]>('HTTP_ERROR_401_ROUTE');

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private dialog = inject(MatDialog);
  private monitoringService = inject(MonitoringService);
  private router = inject(Router);
  private snackbar = inject(MatSnackBar);
  private unauthorizedRoute = inject(HTTP_ERROR_401_ROUTE, { optional: true }) ?? ['access-forbidden'];

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err) {
          switch (err.status) {
            case 400:
              // This code should be handled on each http call as the handled response could be diferent.
              break;
            case 401:
              this.dialog.closeAll();
              this.router.navigate(this.unauthorizedRoute, { replaceUrl: true });
              break;
            case 403:
              this.dialog.closeAll();
              this.router.navigate(['access-forbidden'], { replaceUrl: true });
              break;
            case 429:
              this.showToast('You need to slow down. Try again in a minute.');
              break;
            case 500:
              this.monitoringService.logException(err);
              this.showToast('There was an error. Please try again later');
              break;
            case 0:
            case 503:
              this.showToast('No internet connection');
              break;
            default:
              break;
          }
          return throwError(err);
        }
      })
    );
  }

  private showToast(toastMessage: string): void {
    this.snackbar.open(toastMessage, 'Ok', { verticalPosition: 'top', duration: 3000, panelClass: 'error' });
  }
}
